function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowWhitePrev = function SvgArrowWhitePrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    d: "M26.553.024 7.578 19l18.975 18.976 3.685-3.685L15.131 19 30.422 3.709z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgArrowWhitePrev;